

// export const TEMPLATE_SERVER_URL = 'http://localhost:3000/api';
export const TEMPLATE_SERVER_URL = 'https://salesforce-service.herokuapp.com/api'

